<template>
  <CommonModal>
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <draggable v-model="form.doctypeList">
        <div v-for="item in form.doctypeList" :key="item.doctypeId" class="order-box">
          {{ item.doctypeName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import {docTypeList,updateDocTypeOrder} from "@/api/document";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        doctypeList: [],
      },
    };
  },
  mounted () {
    this.fetchData();
  },
  methods: {
    async fetchData(){
      try {
        const response = await docTypeList(this.form);
        this.form.doctypeList = response.data.doctypeList;
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.doctypeList.forEach(function (item, index) {
        item.doctypeSort = index;
      });
      await updateDocTypeOrder(this.form);
    },
  }
}
</script>

<style>
</style>